import {
    HotspotTextPosition,
    WalkthroughStep,
} from "@/lib/utils/lomdaV3/types";

export function calloutClasses(pos: HotspotTextPosition) {
    switch (pos) {
        case "top":
            return "bottom-full mb-2 left-1/2 -translate-x-1/2";
        case "start":
            return "end-full me-2 top-1/2 -translate-y-1/2";
        case "end":
            return "start-full ms-2 top-1/2 -translate-y-1/2";
        case "bottom":
        case "auto":
        default:
            return "top-full mt-2 left-1/2 -translate-x-1/2";
    }
}

// A small diamond pointer placed on the callout edge facing the hotspot.
export function tailClasses(pos: HotspotTextPosition) {
    switch (pos) {
        case "top":
            return "bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2";
        case "start":
            return "right-0 top-1/2 -translate-y-1/2 translate-x-1/2";
        case "end":
            return "left-0 top-1/2 -translate-y-1/2 -translate-x-1/2";
        default:
            return "top-0 left-1/2 -translate-x-1/2 -translate-y-1/2";
    }
}

export function resolveNextStepId(
    steps: WalkthroughStep[],
    currentId: string,
    linkStepId: string
): string | null {
    if (linkStepId === "none") return null;
    if (linkStepId && steps.some((s) => s.id === linkStepId)) return linkStepId;
    const index = steps.findIndex((s) => s.id === currentId);
    if (index === -1) return null;
    return steps[index + 1]?.id ?? null;
}
